import React, { useCallback, useState } from 'react';
import { FlatList, Text, View } from 'react-native';
import { useDroitsState } from './Droits.states';
import useDroitsStyles from './Droits.styles';
import { DotationEsag } from '../../api/Dotation/types';
import { InfoCentre } from '../../components/InfoCentre/InfoCentre.component'
import { IconMapper } from '../../lib/generique';
import DetailsModal from '../../components/ModalDetailsDotation/ModalDetailsDotation';
import CardDroit from './CardDroit';
import { DroitsConfig } from './Droits.types';
import useEnTetePage from '../../components/EnTetePage/EnTetePage';

// Configuration centralisée des types de droits
export const DROITS_CONFIG: DroitsConfig = {
  CP: {
    icon: IconMapper[1],
    name: 'Congés Payés',
    unit: 'jours'
  },
  RTT: {
    icon: IconMapper[2],
    name: 'RTT',
    unit: 'jours'
  },
  HS: {
    icon: IconMapper[4],
    name: 'Heures Supplémentaires',
    unit: 'heures'
  }
} as const;

// Composant principal
export const Droits: React.FunctionComponent = () => {
  const { styles } = useDroitsStyles();
  const { EnTete } = useEnTetePage({text: 'Mes Droits'});
  const {
    dotations,
    error,
    hasData
  } = useDroitsState();

  // État pour le modal de détails
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState<DotationEsag | null>(null);
  const [selectedTitle, setSelectedTitle] = useState<string>('');

  const openModal = useCallback((data: any, title: string) => {
    setSelectedData(data);
    setSelectedTitle(title);
    setModalVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalVisible(false);
    setSelectedData(null);
    setSelectedTitle('');
  }, []);

  if (error) {
    return (
      <View style={styles.safeArea}>
        <Text style={styles.titre}>Mes Droits</Text>
        <View style={styles.container}>
          <Text style={styles.dataText}>Erreur: {error}</Text>
        </View>
      </View>
    );
  }

  if(hasData) {
    return(
      <View style={styles.container}>
        {EnTete}
        <FlatList
          data={Object.keys(DROITS_CONFIG) as unknown as (keyof DroitsConfig)[]}
          keyExtractor={(item) => item}
          testID='SC_MAIN_CONTENT'
          renderItem={({item}: {item: keyof DroitsConfig}) => (
            <CardDroit
              codeNature={item}
              config={DROITS_CONFIG[item]}
              dotation={dotations[item]}
              openModal={openModal}
            />
          )}
        />

        {/* Modal de détails */}
        {selectedData && (<DetailsModal
          visible={modalVisible}
          data={selectedData}
          title={selectedTitle}
          onClose={closeModal}
        />)}
      </View>
    )
  }

  return(<InfoCentre icon="counter" message="Aucune dotation n'est actuellement disponible"/>);
};
